
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/rekrutmen",
      function () {
        return require("private-next-pages/rekrutmen/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/rekrutmen"])
      });
    }
  